import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import {
  setCrmLeadsLastActivity,
  clearCrmLeadsLastActivity,
} from "../../../redux/slices/filterSlice";
import Button from "../../Button/Button";
import CheckIcon from "../../../assets/svg/check-icon";
import { CREATED_DATE_PRESETS } from "../../../pages/Crm/components/KanbanGrid/utlis/leadTableColumns";

const LastActivityFilter = ({ onClose }: { onClose: () => void }) => {
  const dispatch = useDispatch();
  const lastActivity = useSelector(
    (state: RootState) => state.filter.crmLeads.lastActivity
  );
  const [selected, setSelected] = useState<string>(
    (lastActivity.value as string) || ""
  );

  const handleApply = () => {
    if (selected) {
      const option = CREATED_DATE_PRESETS.find((o) => o.key === selected);
      dispatch(
        setCrmLeadsLastActivity({
          value: selected,
          displayValue: option?.label || selected,
        })
      );
    }
    onClose();
  };

  const handleClear = () => {
    setSelected("");
    dispatch(clearCrmLeadsLastActivity());
    onClose();
  };

  return (
    <div className="flex flex-col gap-2 mt-2 px-3">
      <h2 className="text-md text-heading-text dark:text-heading-text-dk py-1.5">
        Quick Filters
      </h2>
      {CREATED_DATE_PRESETS.map((option) => (
        <div
          key={option.key}
          onClick={() => setSelected(option.key)}
          className={`flex items-center justify-between border cursor-pointer ${
            selected === option.key
              ? "border-verba-blue dark:border-verba-blue-dk bg-verba-blue-light-card-bg dark:bg-verba-blue-light-card-bg-dk"
              : "border-border-gray dark:border-border-gray-dk"
          } rounded-lg py-[13.5px] px-3`}
        >
          <h3 className="text-md font-medium text-heading-text dark:text-heading-text-dk">
            {option.label}
          </h3>
          {selected === option.key && (
            <CheckIcon className="w-[18px] h-[18px] text-verba-blue dark:text-verba-blue-dk" />
          )}
        </div>
      ))}
      <div className="flex justify-end gap-2 mt-4">
        <Button
          innerText="Clear"
          onClick={handleClear}
          disabled={!lastActivity.value}
          buttonContainerClass="py-1 px-7.5 border border-verba-indigo dark:border-verba-indigo-dk rounded-lg disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-heading-text dark:text-heading-text-dk"
        />
        <Button
          innerText="Apply"
          onClick={handleApply}
          disabled={!selected}
          buttonContainerClass="py-1 px-7.5 rounded-lg bg-verba-indigo dark:bg-verba-indigo-dk disabled:opacity-50 disabled:cursor-not-allowed"
          innerTextClass="text-md font-medium whitespace-nowrap text-pure-white dark:text-pure-white-dk"
        />
      </div>
    </div>
  );
};

export default LastActivityFilter;
